const ClaimArea = ({ pqsResponse }) => (
  <div className="claim-number">
    <h4>Claim #{pqsResponse?.claim_number}</h4>
    <div>
      <p>
        {pqsResponse?.street_1} <br />
        {pqsResponse?.city}, {pqsResponse?.state_province} {pqsResponse?.postal_code}
      </p>
    </div>
  </div>
);

export default ClaimArea;
